/** These are known authoring exclusions, not proof of deployed consumer/provider readiness. */
export const voicemailSupportReason = (context: {
  campaignType?: string;
  squad?: boolean;
  transcriberKind?: string;
  llmProviderKey?: string;
  hasWorkflow?: boolean;
  hasMcpTools?: boolean;
  muteUntilGreeting?: boolean;
  turnDetection?: string;
  interruptionMode?: string | null;
}) => {
  if (context.campaignType && context.campaignType !== 'outbound')
    return 'Phone voicemail screening is supported only for outbound phone campaigns.';
  if (context.squad) return 'Phone voicemail screening does not support squads.';
  if (context.transcriberKind === 'custom')
    return 'Phone voicemail screening requires a standard Deepgram transcriber.';
  if (['gpt-live', 'dify'].includes(context.llmProviderKey || ''))
    return 'Phone voicemail screening requires an ordinary LLM, not a realtime or Dify agent.';
  if (context.hasWorkflow)
    return 'Phone voicemail screening does not support a Job workflow, including an empty workflow.';
  if (context.hasMcpTools) return 'Phone voicemail screening does not support MCP tools.';
  if (context.muteUntilGreeting)
    return 'Phone voicemail screening cannot be combined with muting input until the greeting.';
  if (
    ['manual', 'realtime_llm'].includes(context.turnDetection || '') ||
    (context.interruptionMode != null && context.interruptionMode !== 'vad')
  )
    return 'Phone voicemail screening requires native VAD ownership.';
  // Public transcriber provider labels may be aliases. The server verifies canonical rows.
  return '';
};
